import React, { FunctionComponent } from 'react'
import { Outlet } from 'react-router-dom'
import styled from 'styled-components'
import { styles } from '../../styles/themes/style'

interface IHubSpotPageProps { }

const HubSpotPage: FunctionComponent<IHubSpotPageProps> = () => {

    return (
        <Container>
            <Outlet />
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${styles.colors.uiBackground};
`

export default HubSpotPage

